import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12h6","key":"svg-0"}],["path",{"d":"M18 19v-14l-4 4","key":"svg-1"}]]

const IconExposureMinus1 = createReactComponent('outline', 'exposure-minus-1', 'ExposureMinus1', __iconNode);

export default IconExposureMinus1;